import Default from 'components/layouts/Default/Default';
import Fancybox from 'components/elements/ImageViewer/Fancybox';

const ContactUs = () => {
  const image = 'https://vergeca.in/G8g2GpupCrxpsED-vergeca-v2-bSfejdRNEKd3Blq/admin_api/images/Coverage-of-ICAI-Materials.jpg';
  return (
    <Default>
      {/* <div className='coverage-image'>
        <img src={image} className='img-responsive'/>
      </div> */}
      <Fancybox
        options={{
          Carousel: {
            infinite: false,
          },
        }}
      >
        <a data-fancybox="gallery" href={image}>
          <div className='coverage-image'>
            <img src={image} className='img-responsive'/>
          </div>
        </a>
      </Fancybox>

    </Default>
  )
}
export default (ContactUs);